export const dearRequestFooterQa = 'dear-request-footer';
